import { render, staticRenderFns } from "./australiaReviewEdit.vue?vue&type=template&id=6c09debe&"
import script from "./australiaReviewEdit.vue?vue&type=script&lang=js&"
export * from "./australiaReviewEdit.vue?vue&type=script&lang=js&"
import style0 from "./australiaReviewEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports